package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.data.dto.leave.LeaveAllowanceDto
import com.evoapps.evoshift.domain.model.LeaveAllowance
import com.evoapps.evoshift.domain.repository.LeaveRepository
import com.evoapps.evoshift.data.remote.AppFirestore

/**
 * SH-113 leave figures in Firestore: workplaces/{wpId}/leave_allowances/{userId}_{year}. The
 * person queries their own (userId == theirs, as the rules require), managers the year's.
 */
class LeaveRepositoryImpl(private val firestore: AppFirestore) : LeaveRepository {

    private fun allowancesOf(workplaceId: String) =
        firestore.collection("workplaces").document(workplaceId).collection("leave_allowances")

    override suspend fun getAllowancesOf(userId: String, workplaceId: String): Result<List<LeaveAllowance>> = runCatching {
        allowancesOf(workplaceId).where { "userId" equalTo userId }.get().documents
            .map { toDomain(it.data<LeaveAllowanceDto>(), workplaceId) }
    }

    override suspend fun getAllowances(workplaceId: String, year: Int): Result<List<LeaveAllowance>> = runCatching {
        allowancesOf(workplaceId).where { "year" equalTo year }.get().documents
            .map { toDomain(it.data<LeaveAllowanceDto>(), workplaceId) }
    }

    override suspend fun saveAllowance(allowance: LeaveAllowance): Result<Unit> = runCatching {
        allowancesOf(allowance.workplaceId).document(LeaveAllowance.docId(allowance.userId, allowance.year)).set(toDto(allowance))
    }

    internal companion object {
        fun toDomain(dto: LeaveAllowanceDto, workplaceId: String) = LeaveAllowance(
            userId = dto.userId,
            workplaceId = workplaceId,
            year = dto.year,
            entitlementDays = dto.entitlementDays,
            carryOverDays = dto.carryOverDays,
            updatedAt = dto.updatedAt,
            updatedBy = dto.updatedBy
        )

        fun toDto(allowance: LeaveAllowance) = LeaveAllowanceDto(
            userId = allowance.userId,
            year = allowance.year,
            entitlementDays = allowance.entitlementDays,
            carryOverDays = allowance.carryOverDays,
            updatedAt = allowance.updatedAt,
            updatedBy = allowance.updatedBy
        )
    }
}
